import { Component } from '@angular/core';

@Component({
  selector: 'stc-apps-api-test-icon',
  templateUrl: './api-test-icon.component.svg',
  styleUrls: ['./api-test-icon.component.scss'],
  standalone: true,
})
export class ApiTestIconComponent {}
